module.exports = __webpack_public_path__ + "static/img/PatternFooterMailingList1.d999032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/PatternFooterMailingList1.jpg
// module id = HrR4
// module chunks = 1